import {
  REBATE_INSIGHTS,
  REBATE_LOAD,
  REBATE_END,
} from './ActionTypes';
import axios from '../../../../axios.conf';
import { history } from '../../../../components/Helpers';
import { toast as globalToast } from '../../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';

export const RebateTypes = (type, data) => {
  return { type, data };
};

export const getRebateInsights = (data) => {
  return (dispatch) => {
    dispatch(RebateTypes(REBATE_LOAD))
    getRebateInsightsAPI(data)
      .then((response) => {

        dispatch(RebateTypes(REBATE_INSIGHTS, response.data.response));
        dispatch(RebateTypes(REBATE_END))
        if (response.data.response?.data?.length > 0) {
          history.push('/rebate-insights-result')
        }
        else
          globalToast.showInfo('No data to show');
      })
      .catch((error) => { dispatch(RebateTypes(REBATE_END)) });
  };
};

const getRebateInsightsAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('/purchase/rebate-insights', data, { headers: headers },);
  return result;
};






